

// // src/redux/reducers/authReducer.js
// const initialState = {
//   token: null,
//   admin: null,
//   isAuthenticated: false,
// };

// export default function authReducer(state = initialState, action) {
//   switch (action.type) {
//     case "LOGIN_SUCCESS":
//       return {
//         ...state,
//         token: action.payload.token,
//         admin: action.payload.admin,
//         isAuthenticated: true,
//       };
//     case "LOGIN_FAIL":
//       return {
//         ...state,
//         token: null,
//         admin: null,
//         isAuthenticated: false,
//       };
//     case "LOGOUT":
//       return {
//         ...state,
//         token: null,
//         admin: null,
//         isAuthenticated: false,
//       };
//     default:
//       return state;
//   }
// }


const initialState = {
  token: null,
  admin: null,
  isAuthenticated: false,
  permissions: [],  // <== New
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        token: action.payload.token,
        admin: action.payload.admin,
        isAuthenticated: true,
      };
    case "SET_PERMISSIONS":  // <== New
      return {
        ...state,
        permissions: action.payload,
      };
    case "LOGIN_FAIL":
    case "LOGOUT":
      return {
        ...state,
        token: null,
        admin: null,
        isAuthenticated: false,
        permissions: [],
      };
    default:
      return state;
  }
}
